import type { IconSvgObject } from './types';

const SidebarRight01Icon: IconSvgObject = [
  ["path", { d: "M19 3C20.6569 3 22 4.34315 22 6V18C22 19.6569 20.6569 21 19 21L5 21C3.34315 21 2 19.6569 2 18V6C2 4.34315 3.34315 3 5 3H19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 7H18.5M17.5 10H18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 3L14 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 10L9 12L7 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default SidebarRight01Icon;
